import { Component, computed, inject, input } from '@angular/core';
import { type OrderCrossSellFormValues } from '@innogy/become-a-customer/state';
import type { StoreProductData } from '@legacy/common-ui-models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { SetValueAction } from 'ngrx-forms';
import { CommonModule } from '@angular/common';
import { CommonUiProgressiveFormsModule } from '@innogy/common-ui/progressive-forms';
import {
  CrntButton,
  CrntFormControlLabel,
  CrntFormControlValidationMessage,
  CrntRadioGroup,
} from '@essent/current-web-angular';
import { UtilsModule } from '@innogy/utils-deprecated';
import { GenericRichTextDirective } from '@core/jss-utils';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

import { CrossSellProductInfoModalComponent } from '../../../modals/cross-sell-product-info-modal.component';
import { OrderFulfillmentStepComponent } from '../order-fulfillment-step.component';

@Component({
  selector: 'wl-order-fulfillment-cross-sell[progressiveFormState]',
  templateUrl: './order-fulfillment-cross-sell.component.html',
  styleUrls: ['./order-fulfillment-cross-sell.component.essent.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CommonUiProgressiveFormsModule,
    CrntRadioGroup,
    CrntFormControlLabel,
    CrntButton,
    CrntFormControlValidationMessage,
    UtilsModule,
    GenericRichTextDirective,
    JssModule,
  ],
})
export class OrderFulfillmentCrossSellComponent extends OrderFulfillmentStepComponent<OrderCrossSellFormValues> {
  private readonly modalService = inject(NgbModal);
  private readonly store$ = inject(Store);

  readonly product = input.required<StoreProductData>();

  override readonly progressiveFormCardContent = computed(() => ({
    title: this.orderContent().crossSellCardTitle,
    subtitle: this.orderContent().crossSellCardSubtitle,
    submitButtonText: this.orderContent().crossSellCardSubmitButton,
    stepNumber: this.stepNumber(),
  }));

  readonly usps = computed(
    () =>
      this.product()
        .content.usps?.slice(0, 3)
        .map((usp) => ({ ...usp, tooltip: '' })) ?? []
  );

  onCardClick($event: Event) {
    $event.preventDefault();

    this.store$.dispatch(
      new SetValueAction(
        this.formState().controls.hasSelectedProduct.id,
        !this.formState().controls.hasSelectedProduct.value
      )
    );
  }

  onMoreInfoClick($event: Event) {
    $event.stopPropagation();

    this.modalService.dismissAll();
    const modal = this.modalService.open(CrossSellProductInfoModalComponent, {
      modalDialogClass: 'modal-shadow',
      animation: true,
      centered: true,
    });
    modal.componentInstance.rendering = this.rendering();
    modal.componentInstance.product = this.product();
    modal.componentInstance.formState = this.formState();
  }
}
